if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keydown', (e) => this.onKeyDown(e));
      this.querySelector('.cart-drawer__overlay')?.addEventListener('click', () => this.close());
      this.querySelectorAll('.drawer__close').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    onKeyDown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}